import * as MoffAPI from '../../constants/MoffAPI';

const initialState = {
  Loading: false,
  Loaded: false,
};

export default function moffAPI(state: any = initialState, action: any) {
  switch (action.type) {
    case MoffAPI.SUCCESS:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case MoffAPI.LOADING:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/MoffAPI.tsx